import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import commentService from '../../services/commentService';

const CommentForm = ({ postId, onCommentAdded }) => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setContent(e.target.value);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check authentication
    if (!authService.isAuthenticated()) {
      navigate('/login');
      return;
    }

    // Validate content
    const trimmedContent = content.trim();
    if (!trimmedContent) {
      setError('Please enter a comment');
      return;
    }

    if (trimmedContent.length > 2000) {
      setError('Comment cannot exceed 2000 characters');
      return;
    }

    try {
      setIsLoading(true);
      setError('');

      const user = authService.getUser();
      const result = await commentService.createComment(postId, user.id, trimmedContent);

      if (result.success) {
        // Clear form
        setContent('');

        // Notify parent component
        if (onCommentAdded) {
          onCommentAdded(result.comment);
        }
      }
    } catch (err) {
      setError(err.message || 'Failed to post comment');
    } finally {
      setIsLoading(false);
    }
  };

  const charCount = content.length;
  const isOverLimit = charCount > 2000;
  const isDisabled = !content.trim() || isOverLimit || isLoading;

  return (
    <div className="cs_comment_form">
      <textarea
        className="cs_comment_textarea"
        placeholder="Share your thoughts..."
        rows="4"
        maxLength="2100"
        value={content}
        onChange={handleChange}
        disabled={isLoading}
      />

      {error && <div className="cs_comment_error">{error}</div>}

      <div className="cs_comment_form_footer">
        <span className={`cs_char_count ${isOverLimit ? 'cs_char_count_error' : ''}`}>
          {charCount}/2000
        </span>
        <button
          className="cs_comment_submit"
          onClick={handleSubmit}
          disabled={isDisabled}
        >
          {isLoading ? 'Posting...' : 'Post Comment'}
        </button>
      </div>
    </div>
  );
};

export default CommentForm;
